/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import Flames from './fire.svg';
import { StyledSimpleHeader } from './headerStyles';
import { EmbersHeaderLogo } from './logo/headerLogo';
export var EmbersSimpleHeader = function EmbersSimpleHeader(props) {
  var className = props.className,
    style = props.style,
    handleClickLogo = props.handleClickLogo;
  return /*#__PURE__*/React.createElement(StyledSimpleHeader, {
    className: classnames('EmbersSimpleHeader-root', {
      className: className
    }),
    style: style
  }, /*#__PURE__*/React.createElement(EmbersHeaderLogo, {
    handleClickLogo: handleClickLogo
  }), /*#__PURE__*/React.createElement("img", {
    src: Flames,
    alt: "fire",
    className: "EmbersHeader-flames"
  }));
};